import mixpanel from 'mixpanel-browser';
import { ConfigService } from '../core/config';
import * as i0 from "@angular/core";
import * as i1 from "../core/config/config.service";
var MixpanelService = /** @class */ (function () {
    function MixpanelService(configService) {
        this.configService = configService;
        this.isTrackingEnabled = false;
        this.PAGE_VIEW = 'Page View';
        this.LOGIN = 'Login';
        this.LOGOUT = 'Logout';
        // Only enable tracking in production environment
        if (this.configService.get('host') === 'prod') {
            mixpanel.init(this.configService.get('mixPanelToken'), {
                debug: false,
                persistence: 'localStorage',
            });
            this.isTrackingEnabled = true;
        }
    }
    MixpanelService.prototype.track = function (event, properties) {
        // Tracking is disabled in non-production environments
        if (!this.isTrackingEnabled) {
            return;
        }
        mixpanel.track(event, properties);
    };
    MixpanelService.prototype.identify = function (userId) {
        // Tracking is disabled in non-production environments
        if (!this.isTrackingEnabled) {
            return;
        }
        mixpanel.identify(userId);
    };
    MixpanelService.prototype.setUserProperties = function (userId, properties) {
        // Tracking is disabled in non-production environments
        if (!this.isTrackingEnabled) {
            return;
        }
        this.identify(userId);
        mixpanel.people.set(properties);
    };
    MixpanelService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MixpanelService_Factory() { return new MixpanelService(i0.ɵɵinject(i1.ConfigService)); }, token: MixpanelService, providedIn: "root" });
    return MixpanelService;
}());
export { MixpanelService };
